const SailorCommon = Mach.requireModule('SLCommon');

export default class ShopNameItemModel {
  originalData = null;
  constructor(data, landscapeJSXElements, landscapeRichTextContents, extraCardData, changeCardData) {
    this.originalData = data;
    if (changeCardData) {
      // 计算文字长度，超过一定长度则禁止动态标签展示两行
      const shopName = data.name || '';
      const textWidth = SailorCommon.widthForText({
        content: shopName,
        fontFamily: 'KeeTa-Bold',
        fontSize: 16,
        bold: 1,
      });
      const fixWidth = Mach.env.isIOS ? 2 : 6.5; // 一些机型宽度可能会算不准，这里加大下修正值
      const shouldDynamicTagsTwoLines = textWidth + fixWidth < Mach.env.screenWidth - 148 - 20;
      changeCardData({
        shouldDynamicTagsTwoLines
      });
    }
  }
}
